import ArgType, {withErrorsAllowed} from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import flatten from 'notebook/tables/excess/util/flatten';
import {EvaluablePrimitive} from 'notebook/tables/typed-values/DataTypes';
import {CANONICAL_FORMAT} from 'util/DateConstants';
import {isValidDate, isValidDatetime} from 'util/DateUtil';

export default {
  name: 'ISNUMBER',
  category: FunctionCategory.LOGIC,
  shortDescription: 'Checks whether a value is a number.',
  // TODO: Note this deviation from Excel and Sheets: returns true for ranges that only contain numbers.
  description: 'Checks whether a value is a number. Dates and Datetimes are considered numbers.',
  params: [
    {
      name: 'value',
      type: withErrorsAllowed(ArgType.any),
      description: 'The cell or range to be verified as numbers.',
    },
  ],
  eval: (...values): boolean =>
    flatten(values).every((value) => typeof value === 'number' || isTableDateOrDatetime(value)),
} satisfies EvaluablePrimitiveSpreadsheetFunction;

/** Returns true for YYYY-MM-DD and ISO Datetimes */
function isTableDateOrDatetime(value: EvaluablePrimitive | util.CellError): boolean {
  return (
    typeof value === 'string' &&
    value !== '' &&
    (isValidDate({textValue: value}) ||
      isValidDatetime({textValue: value, validDatetimeFormats: [CANONICAL_FORMAT]}))
  );
}
